// extracted by mini-css-extract-plugin
module.exports = {"banner":"plugins_banner__45_3i","guestMessage":"plugins_guestMessage__9gm6P"};